<!-- begin main content -->
<div class="container " role="main" id="main-content">
  <loading #loadingSpinner></loading>
  <div class="row">
    <div class="col-md-12 acl-container">
      <loading #loadingSpinner></loading>
      <div class="col-md-12">
        <div class="row border-bottom-gray-light">
          <div class="col-md-6 pl-0">
            <h1 class="border-none">Data Submissions</h1>
          </div>
          <!-- .end col-md-6 -->
          <div class="col-md-3 pr-0 col-md-push-3">
            <!-- .begin year picker dropdown -->
            <fiscalYearDropdown></fiscalYearDropdown>
            <!-- .end year picker dropdown -->
          </div>
          <!-- .end col-md-3 -->
        </div>
        <!-- .end row -->
      </div>


      <div class="row">
        <div class="col-md-12">
          <div class="flex-list panel-group">
            <!-- card -->
            <a tabindex="0" class="flex-list-item" id="responsibility" [routerLink]="['../dataSubmissionResponsibility']" (keydown.enter)="$event.target.click()" routerLinkActive="router-link-active">
              <div class="panel panel-primary-inverted flex-list-content">
                <div class="panel-body">
                  <p>
                    <strong>Data Submissions Responsibility</strong>
                  </p>
                  <hr />
                  <small>Identify the data submission responsibility for the year between AAAs and the state. </small>
                </div>
              </div>
            </a>
            <!-- end card -->
            <!-- card -->
            <a tabindex="0" class="flex-list-item" id="statedata" (click)="navActionState()" (keydown.enter)="$event.target.click()" routerLinkActive="router-link-active">
              <div class="panel panel-primary-inverted flex-list-content">
                <div class="panel-body">
                  <p>
                    <strong>State-Provided Data</strong>
                  </p>
                  <hr />
                  <small>Enter data for sections responsible by the state.</small>
                </div>
              </div>
            </a>
            <!-- end card -->
            <!-- card -->
            <a tabindex="0" class="flex-list-item" id="aaasubmissions" (click)="navActionAAA()" (keydown.enter)="$event.target.click()" routerLinkActive="router-link-active">
              <div class="panel panel-primary-inverted flex-list-content">
                <div class="panel-body">
                  <p>
                    <strong>AAA Submissions</strong>
                  </p>
                  <hr />
                  <small>Check AAA data entry status and review AAA data submissions</small>
                </div>
              </div>
            </a>
            <!-- end card -->
          </div>
          <!-- end flex-list panel-group -->
          <acl-state-rollup 
            [canGenerateRollup]="canGenerateRollup"
            [rollup]="rollup" 
            (uploadStateRollup)="uploadStateRollup()" 
            (navAction)="navActionRollup()" 
            (rollupModal)="showRollupConfirm()">
          </acl-state-rollup>
        </div>
        <!-- end col-md-12 -->
      </div>
      <!-- end row -->
    </div>
    <!--  end col-md-12 acl-container -->
  </div>
  <!-- end row -->
</div>
<!-- end container -->

<div class="modal fade in" tabindex="-1" id="rollupModal">
  <div class="container" role="main" id="main-content">
    <div class="row">
        <div class="col-md-12 acl-container">
            <div>
                <h2>State and AAA Selection</h2>
                <div class="mb-2">
                  <acl-rollup-multiselect 
                    [grantees]="availableGrantees" 
                    [(selected)]="selectedGrantees"
                    (selectedChange)="selectedChange($event)">
                  </acl-rollup-multiselect>
                  <hr />
                </div>
                <div class="container-fluid col-md-8 mt-1">
                    <button class="btn btn-primary" (click)="generateStateRollup()" data-dismiss="modal" [disabled]="disableSave">Generate roll-up</button>
                    <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button>
                </div>
                <!-- .end container-fluid .end col-md-8 -->
            </div>
            <!-- .end col-md-9 -->
        </div>
        <!-- .end acl-container (col-md-12) -->
    </div>
  </div>  
</div>

<div class="modal fade" id="vadConfirmModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-xlg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h2 class="modal-title" id="myModalLabel" style="color: #B12028;"><b>Confirm Data Rollup</b></h2>
      </div>
      <div class="modal-body">
        <p style="text-align: center;"><img src="../../assets/images/warning.png" alt="warning icon" /></p>
        <p>          
          <br><strong>Warning: Previously provided variance explanations will be deleted.</strong>
           <br /> <br /> <b>Back up any data you want to keep before proceeding</b>
          <br /> <br />
          <input type="checkbox" [checked]="chkRollupConfirmed" (change)="toggelConfirmRollup($event)" name="chkRollupConfirm" id="chkRollupConfirm">
          <label for="chkRollupConfirm" style="color: #B12028;">&nbsp;&nbsp;I wish to proceed and understand all data will be rolled up for this fiscal year</label>
        </p>
      </div>
      <div class="modal-footer">
        <button id="varConfirmClose" type="button" class="btn btn-default" data-dismiss="modal" (click)="cancelBtn()">No</button>
        <button id="varConfirmYes" type="button" [disabled]="!chkRollupConfirmed" class="btn btn-primary" data-dismiss="modal"
                (click)="showRollupOptions();"  type="submit">Yes</button>
      </div>
    </div>
  </div>
